// @ts-nocheck
import React, { useState } from 'react';
import { useCompanyContext } from '../context/CompanyContext';
import { WorkflowStepBody } from '../components/WorkflowStepBody';
import { useNavigateWorkflowStep } from './workflowStepNav';

interface WorkflowPageProps {
  stepId: string;
  children: (ctx: {
    data: any;
    setData: any;
    navigateTo: any;
    parachuteSubTab: string;
    setParachuteSubTab: (id: string) => void;
    parachuteEquitySubTab: string;
    setParachuteEquitySubTab: (id: string) => void;
    documentsSubTab: string;
    setDocumentsSubTab: (id: string) => void;
  }) => React.ReactNode;
}

export default function WorkflowPage({ stepId, children }: WorkflowPageProps) {
  const {
    data,
    setData,
    navigateTo,
    parachuteSubTab,
    setParachuteSubTab,
    parachuteEquitySubTab,
    setParachuteEquitySubTab,
    documentsSubTab,
    setDocumentsSubTab,
  } = useCompanyContext();
  const [parachuteExpanded, setParachuteExpanded] = useState(true);
  const [documentsExpanded, setDocumentsExpanded] = useState(true);
  const setSelectedStepId = useNavigateWorkflowStep(navigateTo);

  return (
    <WorkflowStepBody
      formData={data}
      selectedStepId={stepId}
      setSelectedStepId={setSelectedStepId}
      parachuteSubId={parachuteSubTab}
      setParachuteSubId={setParachuteSubTab}
      parachuteEquitySubId={parachuteEquitySubTab}
      setParachuteEquitySubId={setParachuteEquitySubTab}
      parachuteExpanded={parachuteExpanded}
      setParachuteExpanded={setParachuteExpanded}
      documentsSubId={documentsSubTab}
      setDocumentsSubId={setDocumentsSubTab}
      documentsExpanded={documentsExpanded}
      setDocumentsExpanded={setDocumentsExpanded}
    >
      {children({
        data,
        setData,
        navigateTo,
        parachuteSubTab,
        setParachuteSubTab,
        parachuteEquitySubTab,
        setParachuteEquitySubTab,
        documentsSubTab,
        setDocumentsSubTab,
      })}
    </WorkflowStepBody>
  );
}
